import { createAsyncComponentWithReducer, getLogger, RequirePromiseBody } from '../../shared';
import type * as ReactType from 'react';
import type { Store } from 'redux';

export const DebugDialogAsync = createAsyncComponentWithReducer(
    () =>
        import(/* webpackChunkName: "DebugDialog" */ './debugDialogLazyIndex').catch(error => {
            // Loading js chuck has failed
            getLogger().log('ChuckLoadFailed', {
                component: 'peopleHubDebugDialog',
                error: error ? error.message : undefined,
            });
            return Promise.reject();
        }) as Promise<RequirePromiseBody<{}>>
) as ReactType.ComponentType<{ store: Store<{}> }>;
